import { useState, FormEvent } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNewsletterSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d62lu425dngp5anjaj00', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#1A3A52] text-white">
      <div className="max-w-7xl mx-auto px-8 lg:px-16 py-16">
        <div className="grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/b286a2ed3ca10247dabf9d64ba360efd/4a2f680fd9270aa1e53542f2d7d9bd09.png" 
                alt="CDE MIPYME Valle de Sula"
                className="h-16 w-auto"
              />
            </div>

            <h3 className="text-2xl font-bold mb-4 leading-tight">
              Impulsamos el Desarrollo Empresarial en el Valle de Sula
            </h3>
            <p className="text-gray-300 mb-8 leading-relaxed">
              Fortalecemos las capacidades de las MIPYMES mediante asesoría técnica, capacitación y acompañamiento integral para el crecimiento sostenible de los negocios en nuestra región.
            </p>

            <div className="mb-6">
              <label className="block text-sm font-semibold mb-3">
                Recibe nuestras convocatorias
              </label>
              <form id="newsletter-form" onSubmit={handleNewsletterSubmit} data-readdy-form className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@email.com"
                  className="flex-1 px-4 py-3 bg-transparent border-b-2 border-white/50 focus:border-white focus:outline-none text-sm placeholder-gray-400"
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-6 py-3 border-2 border-white rounded-lg font-semibold hover:bg-white hover:text-[#1A3A52] transition-all duration-300 disabled:opacity-50 whitespace-nowrap text-sm"
                >
                  {isSubmitting ? 'Enviando...' : 'Suscribirme'}
                </button>
              </form>
              {submitStatus === 'success' && (
                <p className="text-green-300 text-xs mt-2">¡Suscripción exitosa!</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-300 text-xs mt-2">Error al suscribirse. Intenta nuevamente.</p>
              )}
            </div>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Servicios</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('servicios')}
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  Asesoría Empresarial
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicios')}
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  Capacitaciones
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicios')}
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  Formalización
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicios')}
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  Planes de Negocio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicios')}
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  Acceso a Mercados
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Programas</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('programas')}
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  Fortalecimiento Empresarial
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('programas')}
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  Emprendedores en Acción
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('programas')}
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  Acceso a Financiamiento
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('noticias')}
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  Noticias y Eventos
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Contacto</h4>
            <ul className="space-y-3 text-sm">
              <li className="text-gray-300">
                San Pedro Sula, Cortés<br />
                Valle de Sula, Honduras
              </li>
              <li className="text-gray-300">
                Tel: +504 2550-1234
              </li>
              <li className="text-gray-300">
                info@cdemipyme.hn
              </li>
            </ul>

            <div className="mt-6">
              <h5 className="font-semibold mb-3 text-sm">Redes Sociales</h5>
              <div className="flex space-x-3">
                <a
                  href="https://www.facebook.com/share/14WjtBXcsxX/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:bg-white hover:text-[#1A3A52] transition-colors"
                >
                  <i className="ri-facebook-fill"></i>
                </a>
                <a
                  href="https://www.instagram.com/cdemipymervs?igsh=MXQ1eWlucnhkaHNocg%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:bg-white hover:text-[#1A3A52] transition-colors"
                >
                  <i className="ri-instagram-line"></i>
                </a>
                <a
                  href="https://youtube.com/@cdemipymervs?si=zkjL8PZGuYKflsWa"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:bg-white hover:text-[#1A3A52] transition-colors"
                >
                  <i className="ri-youtube-line"></i>
                </a>
                <a
                  href="https://whatsapp.com/channel/0029Vb6BHBp4IBh5TykghK06"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:bg-white hover:text-[#1A3A52] transition-colors"
                >
                  <i className="ri-whatsapp-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <p>© 2025 CDE MIPYME Valle de Sula. Todos los derechos reservados.</p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-white transition-colors">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Términos
            </a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
